import { workOrderStatusList } from "@repo/api";
import { FilterCheckbox } from "@repo/ui";
import { isChecked } from "@repo/utils";

import { FilterListContainer } from "./FilterListContainer";
import { type FilterItemsProps } from "./type";

export const WorkOrderStatusFilter = ({
  actions,
  filters,
}: FilterItemsProps) => {
  return (
    <FilterListContainer id="installation-quotation-status-filter">
      {workOrderStatusList.map((status) => (
        <FilterCheckbox
          key={status}
          id={status}
          value={status}
          label={status ?? "-"}
          checked={isChecked(filters.workOrderStatus, status)}
          onCheckFilter={actions.setWorkOrderStatus}
        />
      ))}
    </FilterListContainer>
  );
};
